// extracted by mini-css-extract-plugin
module.exports = {"article-body":"styles_article-body___AqUn"};